import { Injectable } from "@angular/core";
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { CompanyMasterAdapter, CompanyMaster } from "../Model/company-master";
import { map } from "rxjs/operators";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class CompanyMasterService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "CompanyMaster";

  constructor(
    private httpClient: HttpClient,
    private adapter: CompanyMasterAdapter
  ) {}

  getAll(): Observable<CompanyMaster[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(name, id): Observable<CompanyMaster[]> {
    // If id is <> null, then it is an update and need to make sure
    // not checking for a duplicate on it's on record ID, else
    // check without ID on a create
    if (id != null) {
      const url = `${this.baseURL}/${this.API_NAME}/api/check/duplicate`;
      const params = new HttpParams().set("name", name).set("id", id);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    } else {
      // Creation duplicate check, since no ID.  No need to check by ID
      const url = `${this.baseURL}/${this.API_NAME}/api/get/byName`;
      const params = new HttpParams().set("name", name);
      return this.httpClient.get(url, { params }).pipe(
        // Adapt each item in the raw data array
        map((data: any[]) => data["data"].map(item => this.adapter.adapt(item)))
      );
    }
  }

  update(formData, id) {
    // Format lastUpdated to IBM i standards
    formData.lastUpdated = moment().format("YYYY-MM-DD-HH.mm.ss");

    // Add database ID to the JSON object for update service
    formData.id = id;
    formData.changeID = localStorage.getItem("user");
    const url = `${this.baseURL}/${this.API_NAME}/api/update`;
    return this.httpClient.post(url, formData);
  }

  delete(id) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete`;
    return this.httpClient.post(url, { id: id });
  }

  create(formData) {
    formData.changeID = localStorage.getItem("user");

    const url = `${this.baseURL}/${this.API_NAME}/api/create`;
    return this.httpClient.post(url, formData);
  }
}
